import PropTypes from 'prop-types';
import React from 'react';

class Account extends React.Component {
  static propTypes = {
    children: PropTypes.element
  };

  render() {
    return (
      <article className='container form-container flex-element'>
        <h2>My account</h2>
        { this.props.children }
      </article>
    );
  }
}

export default Account;



// WEBPACK FOOTER //
// ./src/apps/Account/components/AccountMain.js